var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { City } from '../place-api/models/city';
import { convertDate } from '../utils';
export var IdentityCardStatusEnum;
(function (IdentityCardStatusEnum) {
    IdentityCardStatusEnum["Active"] = "active";
    IdentityCardStatusEnum["Deleted"] = "deleted";
})(IdentityCardStatusEnum || (IdentityCardStatusEnum = {}));
export function toIdentityCard(data) {
    if (data === void 0) { data = {}; }
    return __assign(__assign({}, data), { location: new City(data.location), birthDate: convertDate(data.birthDate), dateCreated: convertDate(data.dateCreated), dateModified: convertDate(data.dateModified), dateDeleted: convertDate(data.dateDeleted) });
}
